module.exports = __webpack_public_path__ + "static/media/BauPro-Medium.7a00380e.woff2";